module.exports = __webpack_public_path__ + "static/media/Diverse2.78daaa35.jpg";